import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import TableCrudEnhanced from '../../components/TableCrudEnhanced';

const colorMap = {
    '#102a63': 'Azul Escuro',
    '#004f9f': 'Azul Médio',
    '#00b1eb': 'Azul Claro',
    '#ef7d00': 'Laranja',
    '#50af47': 'Verde',
    '#fbba00': 'Amarelo',
    '#5a328a': 'Roxo',
    '#f93b94': 'Rosa',
};

const TagIndex = () => {
    const navigate = useNavigate();

    const filterConfig = useMemo(() => [        
        {
            type: "text",
            name: "tagDescription",
            label: "Tag Description",
            placeholder: "Tag..."
        },
    ], []);

    // Colunas da tabela
    const columns = useMemo(() => [
        {
            title: "Tag Description",
            dataIndex: "tagDescription",
            key: "tagDescription",
            sortable: true 
        },
        {
            title: "Tag color",
            dataIndex: "tagColor",
            key: "tagColor",
            sortable: true,
            render: (value) => (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span 
                        style={{ 
                            display: 'inline-block', 
                            width: '12px', 
                            height: '12px', 
                            backgroundColor: value, 
                            marginRight: '8px', 
                            borderRadius: '2px',
                            border: '1px solid #ddd' 
                        }} 
                    />
                    {colorMap[value] || value} 
                </div>
            )
        },
        { 
            title: 'Active', 
            dataIndex: 'isActive', 
            key: 'isActive', 
            width: 80,
            render: (value, record, index, handleToggleActive) => (
                <span 
                    className={`badge ${value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleActive && handleToggleActive(record)}
                    title={`Click to ${value ? 'deactivate' : 'activate'}`}
                >
                    {value ? 'Active' : 'Inactive'}
                </span>
            )
        },
        { 
            title: 'Deleted', 
            dataIndex: 'isDeleted', 
            key: 'isDeleted', 
            width: 100,
            render: (value, record, index, _,handleToggleDeleted) => (
                <span 
                    className={`badge ${!value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleDeleted && handleToggleDeleted(record)}
                    title={`Click to ${!value ? 'delete' : 'restore'}`}
                >
                    {!value ? 'Not-Deleted' : 'Deleted'}
                </span>
            )
        }
    ], []);

    // Actions
    const actions = useMemo(() => [
        {
            label: 'Edit',
            onClick: (record) => navigate(`/tag/edit/${record.tagID}`),
            type: 'primary'
        }
    ], [navigate]);

    return (
        <TableCrudEnhanced
            title="Tag"
            apiEndpoint="/tag/getAllTag"
            toggleActiveEndpoint="/tag/toggleActive"
            toggleDeletedEndpoint="/tag/toggleDeleted"
            newRoute="/tag/new"
            columns={columns}
            filterConfig={filterConfig}
            actions={actions}
            rowKey="tagID"
            initialPageSize={10}
            enableFilters={true}
            showAddButton={true}
        />
    );
};

export default TagIndex;
